import {
  NavLinkProps as MantineNavLinkProps,
  NavLink as MantineNavLink,
} from '@mantine/core';

export type NavLinkProps = MantineNavLinkProps;

export const NavLink = MantineNavLink as typeof MantineNavLink;

NavLink.displayName = 'NavLink';
